/**
 * Scrollt zu einem Element, falls sich dieses ausserhalb des Viewports befindet
 *
 * @param element  Element, zu welchem gescrollt werden soll
 * @param behavior Wie soll Scrollvorgang erfolgen
 * @param spacing  Abstand zwischen Header und der oberen Kante des Elements
 */
export function scrollToElement(element, behavior = 'smooth', spacing = 20) {
	if (element.closest('.spu-content') !== null) {
		// Wenn es sich um Element in Lightbox handelt, zu Anfang von Lightbox scrollen
		const container = document.querySelector('.spu-container');

		container.scroll({
			top: element.offsetTop - container.offsetTop - spacing,
			behavior,
		});
	} else {
		// Andernfalls zu Element auf Seite scrollen
		const header = document.querySelector('#brx-header');
		const headerRect = header.getBoundingClientRect();
		const headerHeight = headerRect.bottom;
		const windowHeight = window.innerHeight;
		const elementPosition = element.getBoundingClientRect();
		const elementOffsetTopFromWindow = elementPosition.top + window.scrollY;
		const isAboveViewport = elementPosition.top < headerHeight + spacing;
		const isBelowViewport =
			elementPosition.top > windowHeight - spacing * 5;

		// Nur zum Element scrollen, wenn Anfang ausserhalb des Viewports liegt
		if (isAboveViewport || isBelowViewport) {
			window.scroll({
				top: elementOffsetTopFromWindow - headerHeight - spacing,
				behavior,
			});
		}
	}
}
